import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import OrdersLogTap from "./OrdersLogTap";
import ParistaOfrdersTap from "./ParistaOfrdersTap";

function TabPanel({ children, value, index }) {
	return (
		<Box role="tabpanel" hidden={value !== index} sx={{ pt: 3 }}>
			{value === index && children}
		</Box>
	);
}

const OrderReportsPage = () => {
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	return (
		<Box sx={{ mt: 1 }}>
			<Tabs
				value={activeTab}
				onChange={handleTabChange}
				textColor="primary"
				indicatorColor="primary"
				sx={{
					borderBottom: 1,
					borderColor: "divider",
					"& .MuiTab-root": {
						fontWeight: 600,
						fontSize: "1rem",
					},
				}}
			>
				<Tab label="تقارير الحذف والتعديل" />
				<Tab label="تقارير الباريستا" />
			</Tabs>

			<TabPanel value={activeTab} index={0}>
			<OrdersLogTap />
			</TabPanel>
			<TabPanel value={activeTab} index={1}>
			<ParistaOfrdersTap />
			</TabPanel>
		</Box>
	);
};

export default OrderReportsPage;
